import { render, staticRenderFns } from "./MarcasEquiv.vue?vue&type=template&id=309c9e84&scoped=true&"
import script from "./MarcasEquiv.vue?vue&type=script&lang=js&"
export * from "./MarcasEquiv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../bym/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309c9e84",
  null
  
)

export default component.exports